import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import MarketingVideoBlockData from 'app/Models/Content/MarketingVideoBlockData';
import React, {useRef, useState, useEffect, useCallback} from 'react';
import {getVideoLink} from 'app/utilities/ImageProps';
import {isMobile} from 'react-device-detect';
import {useInView} from 'react-intersection-observer';
import HiddenStopAndStartButton from 'app/utilities/HiddenStopAndStartButton';
import {Player, BigPlayButton} from 'video-react';

const MarketingVideoBlock = ({data, context}: ComponentProps<MarketingVideoBlockData>) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [swiperIsStop, setSwiperIsStop] = useState<Boolean>(false);
  const [swiperAutoPlay, setSwiperAutoPlay] = useState('Stop');

  const {ref, inView, entry} = useInView();

  useEffect(() => {
    if (!entry) return;

    if (swiperIsStop || !inView) {
      videoRef.current?.pause();
      setSwiperAutoPlay('Start');
    } else if (inView) {
      videoRef.current?.play();
      setSwiperAutoPlay('Stop');
    }
  }, [inView, entry, videoRef, swiperIsStop]);

  const videoRefCallback = useCallback((node: HTMLVideoElement) => {
    videoRef.current = node;
    ref(node);
  }, []);
  const videoUrl = data?.mobileVideo?.value || data?.video?.value ? getVideoLink(isMobile ? data.mobileVideo : data.video, context) : null;

  return (
    <div className='MarketingVideoBlock'>
      <HiddenStopAndStartButton className='' onClick={() => setSwiperIsStop((prevState) => !prevState)} swiperAutoPlay={swiperAutoPlay} />

      {videoUrl && (
        <Player fluid playsInline src={videoUrl}>
          <BigPlayButton position='center' />
        </Player>
      )}
    </div>
  );
};

export default MarketingVideoBlock;
